export default __webpack_public_path__ + "static/media/Undraw_Books.64f45ed2.svg";